module.exports = __webpack_public_path__ + "media/packs/images/inland-2f2ebc85848961774ff1b331372ecbfb.svg";